import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import _ from 'lodash';
import {
	SearchBar,
	Builder,
	EntityList,
	Pagination,
	Breadcrumb,
	Loader,
	Icon,
	Button,
} from './../../components';
import breadcrumbLib from './../../lib/breadcrumb-lib';
import graphqlLib from './../../lib/graphql-lib';
import { closeGlobalModal } from '../../actions/global-modal';
import { setGlobalMsg } from '../../actions/global-msg';
import EditFTPConfigPane from './AddEditPane';

// Import the CSS
import '../../../scss/containers/builders/_list.scss';

const DEFAULT_LIMIT = 10;

export class BuilderList extends Component {
	state = {
		paths: [{ url: '/corporations', label: 'Corporations' }],
		filter: this.props.location.query.filter || '',
		showFTPConfigPane: false,
	};

	componentWillMount() {
		if (Number.isNaN(+this.props.params.corpId)) {
			this.props.actions.setGlobalMsg('error', 'Invalid corporation id');
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			(!this.props.corporationQuery.error && nextProps.corporationQuery.error) ||
			(!this.props.buildersQuery.error && nextProps.buildersQuery.error)
		) {
			this.props.actions.setGlobalMsg('error', 'An internal server error occurred.');
		}
	}

	handleClickAddEditFTPConfig = e => {
		e.preventDefault();

		this.setState({
			showFTPConfigPane: true,
		});
	};

	handleRowClick = (e, builder) => {
		e.preventDefault();
		browserHistory.push(this.props.location.pathname + '/builders/' + builder.rawId);
	};

	handleCloseFTPConfigPane(refetchCorporation = false) {
		this.setState({
			showFTPConfigPane: false,
		});

		if (refetchCorporation) {
			this.props.corporationQuery.refetch();
		}
	}

	onSearchText = filter => {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page: 1,
				filter,
			},
		});
	};

	onPageChange = page => {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page,
			},
		});
	};

	renderBuilders = builders => {
		if (!builders.length) {
			return <div>No results found.</div>;
		}

		return builders.map(b => <Builder key={b.id} builder={b} onClick={this.handleRowClick} />);
	};

	render() {
		const hasEditLeadFTPConfigPermission = this.props.user.can('edit-lead-ftp-config');
		const corporationQuery = _.get(this.props, 'corporationQuery', {});
		const buildersQuery = _.get(this.props, 'buildersQuery', {});
		const corporation = _.get(corporationQuery, 'corporation');
		const leadsFTPConfig = _.get(corporationQuery, 'corporation.leadsFTPConfig', {});
		const builderResults = _.get(buildersQuery, 'builders.results', []);
		const builderNumTotal = _.get(buildersQuery, 'builders.numTotal', 0);
		const searchText =
			this.state.filter !== null ? this.state.filter : this.props.location.query.filter;
		const locationQuery = this.props.location.query;

		let path = this.state.paths;
		if (corporation) {
			path = breadcrumbLib.addCorporationToPath(path, corporation);
		}

		let pagination;
		if (!buildersQuery.loading) {
			pagination = {
				pages: {
					total: builderNumTotal ? Math.ceil(builderNumTotal / DEFAULT_LIMIT) : 0,
					current: Number(locationQuery.page) || 1,
				},
			};
		}

		if (
			!this.props.corporationQuery ||
			!this.props.buildersQuery ||
			corporationQuery.error ||
			buildersQuery.error
		) {
			return null;
		}

		if (corporationQuery.loading) {
			return <Loader overlay />;
		}

		return (
			<div className="wrapper">
				<Breadcrumb paths={path} />
				<div className="container builder-list">
					<div className="builder-list-header-container">
						<div className="corporation-info-container">
							<h1 className="row corporation-info-name">{corporation.name}</h1>
							<div className="row">
								<div className="corporation-info">
									<div>Corporation ID: {corporation.rawId}</div>
								</div>
								<div className="corporation-info">#{corporation.number}</div>
								<div className="corporation-info">
									<div className="row">
										<Icon type="pin" />
										{corporation.state && <div>{corporation.state}</div>}
									</div>
								</div>
								{corporation.email && (
									<div className="corporation-info">
										<div className="row">
											<Icon type="mail" />
											<a href={'mailto:' + corporation.email}>
												{corporation.email}
											</a>
										</div>
									</div>
								)}
								{corporation.paidBuilderId && (
									<div className="corporation-info">
										<div>Paid Builder ID: {corporation.paidBuilderId}</div>
									</div>
								)}
								{corporation.ssid && (
									<div className="corporation-info">
										<div>SSID: {corporation.ssid}</div>
									</div>
								)}
							</div>
						</div>
						{hasEditLeadFTPConfigPermission && (
							<div className="corporation-edit-ftp-config-container">
								<Button
									action={leadsFTPConfig ? 'edit-ftp-config' : 'add-ftp-config'}
									onClick={e => this.handleClickAddEditFTPConfig(e, corporation)}>
									{leadsFTPConfig ? 'Edit FTP Config' : 'Add FTP Config'}
								</Button>
							</div>
						)}
					</div>

					<div className="row line"></div>
					<div className="row">
						<div className="cell santas-gray">
							<h4>DIVISIONS</h4>
						</div>
						<div className="cell justify-center">
							<Loader visible={this.props.buildersQuery.loading} />
						</div>
						<div className="cell justify-right">
							<SearchBar value={searchText} onEnter={this.onSearchText} />
						</div>
					</div>
					<EntityList>{this.renderBuilders(builderResults)}</EntityList>
					{pagination && (
						<Pagination
							totalPages={pagination.pages.total}
							currentPage={pagination.pages.current}
							onPageChange={this.onPageChange}
						/>
					)}
				</div>
				<EditFTPConfigPane
					title={
						leadsFTPConfig ? 'Edit Lead XML Feed Config' : 'Add Lead XML Feed Config'
					}
					visible={this.state.showFTPConfigPane}
					corporation={corporation}
					onClose={() => this.handleCloseFTPConfigPane()}
					onSave={() => this.handleCloseFTPConfigPane(true)}
				/>
			</div>
		);
	}
}

BuilderList.propTypes = {
	user: PropTypes.object,
	corporationQuery: PropTypes.object,
	buildersQuery: PropTypes.object,
	location: PropTypes.object,
	error: PropTypes.object,
	children: PropTypes.node,
	actions: PropTypes.object,
	params: PropTypes.object,
};

function getBuildersFilters(props) {
	const corporationId = graphqlLib.encodeId('corporation', props.params.corpId);

	let filter = {
		deletedAt: {
			null: true,
		},
		corporationId: { eq: corporationId },
	};

	if (props.location.query.filter) {
		filter.query = `%${props.location.query.filter}%`;
	}

	return filter;
}

function getOffset(props) {
	let offset = 0;
	const limit = props.location.query.limit || DEFAULT_LIMIT;

	if (props.location.query.page) {
		offset = (parseInt(props.location.query.page, 10) - 1) * limit;
	}

	return offset;
}

const corporationQuery = gql`
	query fetchCorporation($corporationId: EncodedID!) {
		corporation(id: $corporationId) {
			id
			rawId: id(raw: true)
			name
			number
			state
			email
			builderCount
			paidBuilderId
			leadsFTPConfig {
				id
				corporationId
				server
				ftpFolder
				remoteLogin
				remotePassword
				transferType
				feedHasEmailEnabled
			}
			ssid
		}
	}
`;

const buildersQuery = gql`
	query fetchBuilders($filter: BuilderFilters!, $limit: Int!, $skip: Int!) {
		builders(filter: $filter, limit: $limit, skip: $skip) {
			...BuilderResults
		}
	}
	${Builder.fragments.builder}
`;

export default compose(
	connect(
		state => {
			return {
				user: state.auth.user,
			};
		},
		dispatch => {
			return {
				actions: {
					setGlobalMsg: bindActionCreators(setGlobalMsg, dispatch),
					closeGlobalModal: bindActionCreators(closeGlobalModal, dispatch),
				},
			};
		},
	),
	graphql(corporationQuery, {
		name: 'corporationQuery',
		skip: props => Number.isNaN(+props.params.corpId),
		options: props => ({
			variables: {
				corporationId: graphqlLib.encodeId('corporation', props.params.corpId),
			},
		}),
	}),
	graphql(buildersQuery, {
		name: 'buildersQuery',
		skip: props => Number.isNaN(+props.params.corpId),
		options: props => ({
			fetchPolicy: 'network-only',
			variables: {
				filter: getBuildersFilters(props),
				limit: props.location.query.limit || DEFAULT_LIMIT,
				skip: getOffset(props),
			},
		}),
	}),
)(BuilderList);



// WEBPACK FOOTER //
// ./src/assets/js/containers/builders/List.js